/**
 * Warnung „Überlappung > 1 Tag" in den Betreuungs-Formularen. Speichern
 * bleibt möglich — der Absende-Knopf des Formulars heißt dann „Trotzdem …".
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../lib/dateFormat';
import type { CareOverlapInfo } from '../../lib/careOverlap';

export function CareOverlapWarning({ overlap, dark }: { overlap: CareOverlapInfo; dark: boolean }) {
  const { t } = useTranslation();
  const period = overlap.enddatum
    ? `${formatDate(overlap.startdatum)} – ${formatDate(overlap.enddatum)}`
    : t('pflege.cares.overlap.open_since', { date: formatDate(overlap.startdatum) });
  return (
    <div
      role="alert"
      data-testid="care-overlap-warning"
      style={{
        padding: '10px 12px', borderRadius: 8, fontSize: 12.5, lineHeight: 1.45,
        background: dark ? '#3a2a0f' : '#fffaeb', border: '1px solid #fec84b', color: dark ? '#fec84b' : '#93370d',
      }}
    >
      <strong style={{ display: 'block', marginBottom: 2 }}>
        {overlap.open_ended
          ? t('pflege.cares.overlap.title_open')
          : t('pflege.cares.overlap.title', { count: overlap.days })}
      </strong>
      {t('pflege.cares.overlap.with', { name: overlap.bk_name || `#${overlap.care_id}`, period })}
      <div style={{ marginTop: 4 }}>{t('pflege.cares.overlap.hint')}</div>
    </div>
  );
}
